import { render, staticRenderFns } from "./Restoration1.vue?vue&type=template&id=01bef959&scoped=true"
import script from "./Restoration1.vue?vue&type=script&lang=js"
export * from "./Restoration1.vue?vue&type=script&lang=js"
import style0 from "./Restoration1.vue?vue&type=style&index=0&id=01bef959&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bef959",
  null
  
)

export default component.exports